import { render, staticRenderFns } from "./alertmsg.vue?vue&type=template&id=76f79865&"
import script from "./alertmsg.vue?vue&type=script&lang=js&"
export * from "./alertmsg.vue?vue&type=script&lang=js&"
import style0 from "./alertmsg.vue?vue&type=style&index=0&id=76f79865&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports